import { SALESAXIS_ITEMS, SALESAXIS_SECTIONS, SALESAXIS_SCALE } from "./questionBank.js";
import { scoreSalesAxis, getSPIBand, SPI_BANDS } from "./scoring.js";
export { SALESAXIS_ITEMS, SALESAXIS_SECTIONS, SALESAXIS_SCALE, SPI_BANDS, getSPIBand };

const SALESAXIS = {
  id:           "salesaxis",
  name:         "SalesAxis",
  shortName:    "SalesAxis",
  icon:         "🏆",
  color:        "#0B2545",
  bg:           "#EFF6FF",
  description:  "24-item Sales Personality Index assessment covering Personality, Knowledge and Motivation. Produces a Sales Personality Index (SPI) score 0-48 with PDF report.",
  desc:         "24 items · 3 sections · SPI score · PDF report",
  publisher:    "AXIS360 Express",
  version:      "1.0",
  itemCount:    24,
  items:        24,
  timeLimit:    15,
  time:         "15 min",
  timeEstimate: "~15 min",
  format:       "likert",
  scaleType:    "likert-5",
  isScreener:   true,
  isExpress:    true,
  pricingTier:  "volume",
  creditCost:   20,
  pagesOf:      8,
  totalPages:   3,
  questions:    SALESAXIS_ITEMS,
  dimensions:   SALESAXIS_SECTIONS,
  score(answers) { return scoreSalesAxis(answers); },
};
export default SALESAXIS;
